


















































































































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import { CrudService } from '@/data/services/crud.service';
import { CampaignService } from '@/data/services/campaign.service';
import { Campaign, CampaignContact, CampaignTopStats } from '@/data/models/campaign.model';
import { Search, SortDirection } from '@/data/models/search.model';
import CampagnaContattiSearch from './CampagnaContattiSearch.vue';
import TopstatsCounter from '@/@core/components/topstats/TopstatsCounter.vue';
import CampagnaContattiTableFilter from './CampagnaContattiTableFilter.vue';
import CampagnaContattiOperatore from './CampagnaContattiOperatore.vue';
import { User } from '@/data/models/user.model';

@Component({
	components: {
		TopstatsCounter,
		CampagnaContattiTableFilter,
		CampagnaContattiOperatore
	},
})
export default class CampagnaContattiList extends Vue {
	@Prop() campagna!: Campaign;
	@Prop() editable!: boolean;

	@Inject('CrudService') crudService!: CrudService<CampaignContact>;
	@Inject('CampaignService') campaignService!: CampaignService;

	rows: CampaignContact[] = [];
	loading: boolean = false;
	ct: number = 0;

	advancedSearch: Search = new Search('campaigncontact');
	topstats: CampaignTopStats[] = [];
	checkedRows: CampaignContact[] = [];

	constructor() {
		super();
		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	created() {
		if (this.campagna && this.campagna.id)
			this.loadTopStats();
	}

	loadTopStats() {
		this.campaignService.getCampaignContactStats(this.campagna.id)
			.then((results: CampaignTopStats[]) => {
				this.topstats = results;
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	loadContatti() {
		this.advancedSearch.addSimpleFilter('campaignid', this.campagna.id);

		const datareq = this.crudService.searchEntities(
			CampaignContact,
			'campaigncontact',
			this.advancedSearch,
			this.advancedSearch.page
		);
		const countreq = this.crudService.countEntities(
			CampaignContact,
			'campaigncontact',
			this.advancedSearch
		);
		this.loading = true;
		Promise.all([datareq, countreq])
			.then((results) => {
				this.rows = results[0];
				this.advancedSearch.page.setTotal(results[1].ct);
				this.ct = results[1].ct;
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			})
			.finally(() => (this.loading = false));
	}

	onSearch(event: any) {
		if (event) {
			this.advancedSearch = event;
			this.loadContatti();
		}
	}

	assignOperator(row?: CampaignContact) {

		const ids = (row) ? [row.id] : this.checkedRows.map(c => c.id);

		const modal = this.$buefy.modal.open({
			parent: this,
			component: CampagnaContattiOperatore,
			width: 600,
			canCancel: false,
			props: {
				assign: true
			},
			events: {
				submit: (user: User) => {
					this.campaignService
						.assignOperator(ids, user.id)
						.then(() => {
							this.$buefy.notification.open({
								message: this.$t('operator-assigned').toString(),
								type: 'is-success',
							});
							this.checkedRows = [];
							this.loadContatti();
							modal.close();
						})
						.catch(({ data }) => {
							this.$buefy.notification.open({
								message: data.msg || data.internal,
								type: 'is-danger',
							});
						});
				},
			},
		});
	}

	unassignOperator(row?: CampaignContact) {
		const ids = (row) ? [row.id] : this.checkedRows.map(c => c.id);

		this.$buefy.dialog.confirm({
			message: this.$t('warning-unassign-operator') as string,
			type: 'is-warning',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.campaignService
					.unassignOperator(ids)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('operator-unassigned').toString(),
							type: 'is-success',
						});
						this.checkedRows = [];
						this.loadContatti();
					})
					.catch(({ data }) => {
						this.$buefy.notification.open({
							message: data.msg || data.internal,
							type: 'is-danger',
						});
					});
			},
		});
	}

	removeContatti(row?: CampaignContact) {
		const ids = (row) ? [row.id] : this.checkedRows.map(c => c.id);

		this.$buefy.dialog.confirm({
			message: this.$t('warning-remove-contacts') as string,
			type: 'is-warning',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.campaignService
					.delete(ids)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('osuccess-save').toString(),
							type: 'is-success',
						});
						this.checkedRows = [];
						this.loadContatti();
					})
					.catch(({ data }) => {
						this.$buefy.notification.open({
							message: data.msg || data.internal,
							type: 'is-danger',
						});
					});
			},
		});
	}

	addContatti() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: CampagnaContattiSearch,
			width: 1280,
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (request: Search, ct: number) => {
					const loading = this.$buefy.loading.open({});
					this.campaignService
						.linkCampaignContacts(this.campagna.id, request)
						.then((res) => {
							this.openConfirmModal(res.linked, ct);
							this.loadContatti();
							modal.close();
						})
						.catch(({ data }) => {
							this.$buefy.notification.open({
								message: data.msg || data.internal,
								type: 'is-danger',
							});
						}).finally(() => {
							loading.close();
						});
				},
			},
		});
	}

	openConfirmModal(ct: number | undefined, searchct?: number) {
		this.$buefy.dialog.alert({
			title: this.$t('added-campaign-contacts') as string,
			message: 'Contatti aggiunti: <b>' + ct + '</b><br>Contatti scartati: <b>' + searchct + '</b>',
			type: 'is-primary',
			iconPack: 'fa',
			ariaRole: 'alertdialog',
			ariaModal: true
		});
	}

	deleteContatto(item: CampaignContact) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-contatto-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(CampaignContact, 'campaigncontact', item)
					.then(() => {
						this.loadContatti();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			},
		});
	}

	onPageChange(page: number) {
		this.advancedSearch.page.setPageNumber(page - 1);
		this.loadContatti();
	}

	onSortChange(field: string, dir: string) {
		this.advancedSearch.setSortField(field);
		this.advancedSearch.setSortDirection(dir);
		this.loadContatti();
	}

}
